import { Image, Skeleton } from '@chakra-ui/react';
import React from 'react';
import upload from './upload.svg';
import uploadWhite from './upload-white.svg';
import calendar from './calendar.svg';
import calendarBlue from './calendar-blue.svg';
import excel from './excel.svg';
import questionBlue from './question-blue.svg';
import questionBlack from './question-black.svg';
import informationIcon from './information.svg';
import informationBlackIcon from './information-black.svg';
import filterIcon from './filter-icon.svg';
import sellinIcon from './sellin.svg';
import selloutIcon from './sellout.svg';
import mtdPositiveIcon from './mtd-positive.svg';
import mtdNegativeIcon from './mtd-negative.svg';
import mtdNeutralIcon from './mtd-neutral.svg';
import blackArrow from './black-arrow.svg';
import sortIcon from './sort-icon.svg';
import searchIcon from './search.svg';
import leftArrowIcon from './left-arrow.svg';
import saveWhiteIcon from './save-white.svg';
import syncIcon from './sync-blue.svg';
import filterRemoveIcon from './filter-remove.svg';
import exportIcon from './export-button.svg';
import informationBlueIcon from './information-blue24.svg';
import successGreen24Icon from './success-green24.svg';
import warningRed24Icon from './warning-red24.svg';
import closeRedIcon from './close-red.svg';
import closeTransparentIcon from './close-transparent.svg';
import copyIcon from './copy.svg';
import copyBlueIcon from './copy-blue.svg';
import redoIcon from './redo.svg';
import redoBlueIcon from './redo-blue.svg';
import failedRed32Icon from './failed-red32.svg';
import todoIconCircle from './todo-icon-circle.svg';
import chevronDownIcon from './chevron-down.svg';
import chevronRightIcon from './chevron-right.svg';
import chevronLeftIcon from './chevron-left.svg';
import resyncIcon from './resync.svg';
import resyncblueIcon from './resync-blue.svg';
import badgecheckgreenIcon from './badge-check-green.svg';
import triangleWarningIcon from './triangle-warning.svg';
import editIcon from './edit.svg';
import deleteIcon from './delete.svg';

export const UploadIcon = () => <Image src={upload} />;
export const UploadWhiteIcon = () => <Image src={uploadWhite} />;
export const CalendarIcon = () => <Image src={calendar} />;
export const CalendarBlueIcon = () => <Image src={calendarBlue} />;
export const ExcelIcon = () => <Image src={excel} />;
export const QuestionBlueIcon = () => <Image src={questionBlue} />;
export const QuestionBlackIcon = () => <Image src={questionBlack} />;
export const InformationIcon = () => <Image src={informationIcon} />;
export const InformationBlackIcon = () => <Image src={informationBlackIcon} />;
export const FilterIcon = () => <Image src={filterIcon} />;
export const SellinIcon = ({ transform }) => <Image src={sellinIcon} transform={transform} />;
export const SelloutIcon = () => <Image src={selloutIcon} />;
export const MtdPositiveIcon = () => <Image src={mtdPositiveIcon} />;
export const MtdNegativeIcon = () => <Image src={mtdNegativeIcon} />;
export const MtdNeutralIcon = () => <Image src={mtdNeutralIcon} />;
export const BlackArrowIcon = () => <Image src={blackArrow} />;
export const SortIcon = ({ onClick }) => (
    <Image src={sortIcon} cursor="pointer" onClick={onClick} data-testid="sortIcon" />
);
export const SearchIcon = () => <Image src={searchIcon} />;
export const LeftArrowIcon = ({ onClick }) => <Image src={leftArrowIcon} onClick={onClick} />;
export const SaveWhiteIcon = () => <Image src={saveWhiteIcon} />;
export const SyncIcon = () => <Image src={syncIcon} />;
export const FilterRemoveIcon = ({ onClick }) => (
    <Image data-testid="FilterRemoveIcon" src={filterRemoveIcon} onClick={onClick} />
);
export const ExportIcon = () => <Image src={exportIcon} />;
export const InformationBlue24Icon = () => <Image src={informationBlueIcon} />;
export const SuccessGreen24Icon = ({ width, height, fallback }) => (
    <Image width={width} height={height} src={successGreen24Icon} fallback={fallback} />
);
export const FailedRed32Icon = ({ fallback }) => <Image src={failedRed32Icon} fallback={fallback} />;
export const WarningRed24Icon = () => <Image src={warningRed24Icon} />;
export const CloseRedIcon = ({ width, height }) => <Image src={closeRedIcon} width={width} height={height} />;
export const CloseTransparentIcon = ({ width, height }) => (
    <Image src={closeTransparentIcon} width={width} height={height} />
);
export const CopyIcon = ({ onClick }) => (
    <Image src={copyIcon} cursor="pointer" data-testid="copy-icon" onClick={onClick} />
);
export const CopyBlueIcon = ({ onClick }) => (
    <Image src={copyBlueIcon} cursor="pointer" data-testid="copy-icon" onClick={onClick} />
);
export const RedoIcon = () => <Image src={redoIcon} />;
export const RedoBlueIcon = () => <Image src={redoBlueIcon} />;
export const TodoIconCircle = ({ fallback }) => <Image src={todoIconCircle} fallback={fallback} />;
export const ChevronDownIcon = () => <Image src={chevronDownIcon} />;
export const ChevronRightIcon = () => <Image src={chevronRightIcon} />;
export const ChevronLeftIcon = () => <Image src={chevronLeftIcon} />;
export const ResyncIcon = () => <Image src={resyncIcon} />;
export const ResyncBlueIcon = ({ width, height }) => <Image src={resyncblueIcon} width={width} height={height} />;
export const BadgeCheckGreenIcon = ({ width, height }) => (
    <Image src={badgecheckgreenIcon} width={width} height={height} />
);
export const TriangleWarningIcon = ({ width, height }) => (
    <Image src={triangleWarningIcon} width={width} height={height} />
);
export const EditIcon = ({ width, height }) => <Image src={editIcon} width={width} height={height} />;
export const DeleteIcon = ({ width, height }) => <Image src={deleteIcon} width={width} height={height} />;
